import { TTrackEventData } from '../../../tracking/constant';
export const PRODUCT_OVERVIEW_PAGE_TRACKING_EVENTS = {
    GET_STARTED: {
        component_name: '',
        component_type: 'form',
        form_action: 'submit',
        event: 'form_submit'
    },
    FAQ_OPEN: {
        component_name: '',
        component_type: 'faq',
        component_id: '',
        faq_action: 'open',
        language: '',
        pageGroup: 'courier app overview',
        event: 'faq_open'
    },
    FAQ_SCROLL_TO_BOTTOM:{
        component_type: 'scroll',
        language:'',
        event:'scroll_end',
        pageGroup: 'courier app overview',
    }

}
export const PRODUCT_OVERVIEW_VIDEO_TRACKING_EVENTS = {
    VIDEO_PLAY:
    {
        component_type: 'video',
        video_action: 'play',
        event: 'video_play'
    },
    VIDEO_PAUSE:
    {
        component_type: 'video',
        video_action: 'pause',
        event: 'video_pause'
    },
    VIDEO_CLOSE:
    {
        component_type: 'video',
        video_action: 'close',
        event: 'video_close'
    },
    VIDEO_INPLAY:
    {
        component_type: 'video',
        event: 'video_inPlay'
    }
}


export type TVideoPlay = TTrackEventData<{ video_action: string, component_id: string }>;
export type TVideoPause = TTrackEventData<{ video_action: string, component_id: string }>;
export type TVideoClose = TTrackEventData<{ video_action: string, component_id: string }>;
export type TVideoInplay = TTrackEventData<{ video_action: string, component_id: string }>;
export type TPageGetStarted = TTrackEventData<{ component_id: string, form_action: string }>;
export type TFAQClick = TTrackEventData<{ faq_action: string, component_id: string, pageGroup:string }>;
export type TFAQScrollToBottom = TTrackEventData<{ pageGroup:string }>;
